import React, {useState} from "react";
import PictureSlide from "../../component/PictureSlide";
import vv6 from "../../assets/9.png";
import vv7 from "../../assets/10.png";
import vv8 from "../../assets/11.png";
import vv9 from "../../assets/12.png";
import vv10 from "../../assets/13.png";
import bakimDuyuru from "../../assets/bakim-duyuru-20240419.jpeg";
import Footer from "../../component/Footer";
import {VirtualHost} from "../../constants";
import {Modal} from "antd";

function HomePage() {
  const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
  return (
    <div>
      <Modal
          open={showAnnouncementModal}
          width={"70%"}
          onOk={() => setShowAnnouncementModal(false)}
          onCancel={() => setShowAnnouncementModal(false)}
          footer={(_, {OkBtn}) => (
              <div>
                <OkBtn/>
              </div>
          )}
      >
        <div style={{display:"flex",justifyContent:"center"}}><img style={{width:"95%"}} src={bakimDuyuru} alt=""/></div>
      </Modal>
      <div style={{ backgroundColor: "white" }}>
        <PictureSlide />
      </div>

      <section
        style={{ backgroundColor: "white" }}
        className="u-align-center u-clearfix u-section-2"
        id="sec-c1b2"
      >
        <div className="u-align-left u-clearfix u-sheet u-sheet-1">
          {/*<h5 className="u-text u-text-default u-text-1">*/}
          <h2 className="u-text u-text-default u-text-3 u-align-center u-body">
            <span style={{color: "#b30b4f"}}><b>{VirtualHost.companyName}  Üyeleri;</b></span> <br/>
            <span style={{color:"#111111"}}>Yeme içmeden giyime, marketten kırtasiyeye, </span>
            <span style={{color:"#111111"}}>elektronikten beyaz eşyaya, akaryakıttan sağlığa tüm ihtiyaçlarınızda </span> <span style={{color : "#b30b4f"}}><b>sizlere özel indirimler</b></span> <span style={{color:"#111111"}}> sağlamaktadır!</span>
            <span className="u-text-palette-5-dark-2"></span>
          </h2>
          <h2
            className="u-custom-font u-font-oswald u-text u-text-default u-text-palette-5-dark-2 u-text-1"
            style={{ margin: "32px auto 0" }}
          >
            Nasıl Çalışır?{" "}
          </h2>
          <div className="u-expanded-width u-list u-list-1">
            <div className="u-repeater u-repeater-1">
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-container-layout-1">
                  <span className="u-align-center u-file-icon u-icon u-icon-rectangle u-text-custom-color-1 u-icon-1">
                    <img src={vv6} alt="" />
                  </span>
                  <h3 className="u-align-center u-custom-font u-font-oswald u-text u-text-default u-text-palette-5-dark-2 u-text-4">
                    Teklifinizi Alın{" "}
                  </h3>
                  <p className="u-align-center u-text u-text-3">
                    {" "}
                    Dilediğiniz ürün ve hizmet için teklif isteyin,
                    tedarikçilerimizin size özel tekliflerini paylaşmak için
                    sizi 30 dakika içinde arayalım.
                  </p>
                </div>
              </div>
              <div className="u-align-center u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-container-layout-2">
                  <span className="u-align-center u-file-icon u-icon u-icon-rectangle u-text-custom-color-1 u-icon-2">
                    <img src={vv7} alt="" />
                  </span>
                  <h3 className="u-align-center u-custom-font u-font-oswald u-text u-text-default u-text-palette-5-dark-2 u-text-4">
                    {" "}
                    Sözleşmenizi Doldurun
                  </h3>
                  <p className="u-align-center u-text u-text-5">
                    {" "}
                    Tüm teklif sözleşmelerini online olarak dilediğiniz zaman
                    doldurun. Islak imzanızı iletmek için belgelerinizi
                    kargolamanız yeterli.
                  </p>
                </div>
              </div>
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-container-layout-3">
                  <span className="u-align-center u-file-icon u-icon u-icon-rectangle u-text-custom-color-1 u-icon-3">
                    <img src={vv8} alt="" />
                  </span>
                  <h3 className="u-align-center u-custom-font u-font-oswald u-text u-text-default u-text-palette-5-dark-2 u-text-6">
                    {" "}
                    Tasarrufa Başlayın
                  </h3>
                  <p className="u-align-center u-text u-text-7">
                    {" "}
                    Vakit kaybetmeden hizmet almaya başlayın, şirketinizin gider
                    kalemlerini %60’a varan oranlarda düşürerek tasarruf yapın!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="u-align-center u-clearfix u-section-3" id="sec-7944">
        <div className="u-clearfix u-sheet u-sheet-1">
          <div className="u-expanded-width u-list u-list-1">
            <div className="u-repeater u-repeater-1">
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-container-layout-1">
                  <span className="u-file-icon u-icon u-text-custom-color-1 u-icon-1">
                    <img src={vv9} alt="" />
                  </span>
                  <h4 className="u-align-center u-custom-font u-font-oswald u-text u-text-3">
                    {" "}
                    Sözleşme süreçlerine yenilikçi yaklaşım
                    <span className="u-text-palette-5-dark-2"></span>
                  </h4>
                  <p className="u-align-center u-text u-text-4">
                    {" "}
                    Kırmızı Kurumsal’ın sağlamış olduğu danışmanlar ile tüm
                    anlaşma süreçleri eczanenizden ayrılmadan hızlı bir şekilde
                    tamamlanabilir.{" "}
                  </p>
                </div>
              </div>
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-container-layout-2">
                  <span className="u-file-icon u-icon u-text-custom-color-1 u-icon-2">
                    <img src={vv10} alt="" />
                  </span>
                  <h4 className="u-align-center u-custom-font u-font-oswald u-text u-text-5">
                    {" "}
                    Sektöründe lider tedarikçiler
                  </h4>
                  <p className="u-align-center u-text u-text-6">
                    {" "}
                    Kırmızı Kurumsal sektöründe lider tedarikçiler ile anlaşır,
                    üye işletmeleri en doğru firmalar ile, en avantajlı
                    koşullarla buluşturur.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/page/HomePage/index.js